import React from "react";
import clsx from "clsx";
import { Loader, Package, Truck, Check } from "react-feather";

export default function OrderStatus({ currentStatus }) {
  const statuses = [
    { name: "Pending", icon: <Loader size={18} /> },
    { name: "Processing", icon: <Package size={18} /> },
    { name: "Shipped", icon: <Truck size={18} /> },
    { name: "Delivered", icon: <Check size={18} /> },
  ];

  const currentIndex = statuses.findIndex(
    (status) => status.name.toLowerCase() === currentStatus?.toLowerCase()
  );

  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap">
      {statuses.map((status, index) => {
        const isCompleted = index <= currentIndex;
        const isCurrent = index === currentIndex;

        return (
          <div
            key={status.name}
            className="d-flex flex-column align-items-center flex-fill"
          >
            <div
              className={clsx(
                "rounded-circle d-flex align-items-center justify-content-center mb-2",
                isCurrent
                  ? "bg-success text-white"
                  : isCompleted
                  ? "border border-success text-success"
                  : "border border-secondary text-secondary"
              )}
              style={{
                width: 50,
                height: 50,
              }}
            >
              {status.icon}
            </div>

            <small
              className={clsx(
                isCurrent ? "text-success fw-bold" : "text-muted"
              )}
            >
              {status.name}
            </small>
          </div>
        );
      })}
    </div>
  );
}